function Information() {
    return(
        <span>information</span>
    )
}

export default Information;